import type { DefaultMenuItem, MenuItemDef } from "ag-grid-community";

export type ContextMenuItem<TData = any, TContext = any> = DefaultMenuItem | MenuItemDef<TData, TContext>;

// A getContextMenuItems that returns its own items replaces AG Grid's default menu, so copy
// has to be appended explicitly or right-click loses it. Needs ClipboardModule (in GRID_MODULES).
export function withCopyMenuItems<TData = any, TContext = any>(
  custom: ContextMenuItem<TData, TContext>[] = [],
): ContextMenuItem<TData, TContext>[] {
  const copy: ContextMenuItem<TData, TContext>[] = ["copy", "copyWithHeaders"];
  return custom.length > 0 ? [...custom, "separator", ...copy] : copy;
}
